const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {ALIGNMENT_LE} = require('./../../../../aligmentList')
const {ATTACK_MELEE_WEAPON} = require('./../../../../attackTypeList')
const {CR_0} = require('./../../../../crList')
const {craniumRatsDescriptionList} = require('./../../../../textCommonParts')
const {CREATURE_CRANIUM_RAT} = require('./../../../../creatureIdList')
const {CREATURE_TYPE_BEAST} = require('./../../../../creatureTypeIdList')
const {DAMAGE_PIERCING} = require('./../../../../damageTypeList')
const {GENDER_FEMALE} = require('./../../../../genderList')
const {LANG_TELEPATHY} = require('./../../../../languageIdList')
const {SENSE_DARK_VISION} = require('./../../../../senseList')
const {SIZE_TINY} = require('./../../../../sizeList')
const {SOURCE_VGTM} = require('./../../../../sourceList')
const {SPEED_WALK} = require('./../../../../speedList')

module.exports = {
  name: 'Черепная крыса',
  nameEn: 'Cranium Rat',
  id: CREATURE_CRANIUM_RAT,
  description: craniumRatsDescriptionList,
  sizeType: SIZE_TINY,
  creatureTypeIdList: [
    CREATURE_TYPE_BEAST,
  ],
  alignmentId: ALIGNMENT_LE,
  source: {
    id: SOURCE_VGTM,
    page: 203,
  },
  armor: 12,
  hp: {
    diceCount: 1,
  },
  speed: {
    [SPEED_WALK]: 30,
  },
  params: {
    [PARAM_STR]: 2,
    [PARAM_DEX]: 14,
    [PARAM_CON]: 10,
    [PARAM_INT]: 4,
    [PARAM_WIT]: 11,
    [PARAM_CHA]: 8,
  },
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 30,
    },
  ],
  languageList: [
    {
      id: LANG_TELEPATHY,
      range: 30,
    },
  ],
  cr: CR_0,
  featureList: [
    {
      name: 'Свечение',
      description: `Бонусным действием черепная крыса может испускать тусклый свет из своего мозга в радиусе 5 футов или гасить его.`,
    },
    {
      name: 'Телепатический покров',
      description: `Черепная крыса имеет иммунитет к любому эффекту, который может почувствовать её эмоции или прочесть её мысли, а также ко всем заклинаниям школы прорицания.`,
    },
  ],
  actionList: [
    {
      name: 'Укус',
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 4,
        range: 5,
        hit: {
          type: DAMAGE_PIERCING,
          diceCount: 0,
          diceType: 0,
          diceBonus: 1,
        },
      },
    },
  ],
  genderId: GENDER_FEMALE,
}
